/* tslint:disable */
/* eslint-disable */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { SuccessResponse_1OfList_1OfCostHistory, SuccessResponse_1OfList_1OfItemDailyHistory } from '../types';
import { isAxiosError, throwException } from '../base';

import { IItemHistoryClient } from '../interfaces';
export class ItemHistoryClient implements IItemHistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getitemcosthistoriesbyitemnumber(itemNumber: string, storeNumber: string, date?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        let url_ = this.baseUrl + "/itemhistory/getitemcosthistoriesbyitemnumber?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined and cannot be null.");
        else
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetitemcosthistoriesbyitemnumber(_response);
        });
    }

    protected processGetitemcosthistoriesbyitemnumber(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfCostHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfCostHistory>(<any>null);
    }

    /**
     * @return Success
     */
    getitemdailyhistory(itemNumber: string, storeNumber: string, fromDate: string, toDate: string, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> {
        let url_ = this.baseUrl + "/itemhistory/getitemdailyhistory?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined and cannot be null.");
        else
            url_ += "ItemNumber=" + encodeURIComponent("" + itemNumber) + "&";
        if (storeNumber === undefined || storeNumber === null)
            throw new Error("The parameter 'storeNumber' must be defined and cannot be null.");
        else
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetitemdailyhistory(_response);
        });
    }

    protected processGetitemdailyhistory(response: AxiosResponse): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfList_1OfItemDailyHistory>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfList_1OfItemDailyHistory>(<any>null);
    }
}
